import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group'
import { cn } from '@/lib/utils'

type Props = {
  options: { title: string; value: string; disabled?: boolean; ariaLabel?: string }[]
  defaultValue?: string
  value?: string
  className?: string
  onValueChange?: (value: Props['options'][number]['value']) => void
}

export const ButtonSelector = ({ options, defaultValue, value, className, onValueChange }: Props) => {
  const enabledOptions = options.filter((opt) => !opt.disabled)
  const onlyOneEnabled = enabledOptions.length === 1

  const handleChange = (v: string) => {
    if (onlyOneEnabled) {
      // When only one option is enabled, DO NOT allow deselection
      if (!v) return
      onValueChange?.(v)

      return
    }

    // Normal behavior for multiple enabled options (deselect allowed)
    onValueChange?.(v) // v can be "" here
  }

  return (
    <ToggleGroup type="single" value={value} defaultValue={defaultValue} onValueChange={handleChange} className={cn(className)}>
      {options?.map(({ title, value, disabled, ariaLabel }) => (
        <ToggleGroupItem
          key={value}
          value={value}
          disabled={disabled}
          aria-label={ariaLabel}
          className="w-full"
          onClick={(e) => {
            // To prevent data-state changes when single option is enabled
            if (onlyOneEnabled) {
              e.preventDefault()
              e.stopPropagation()
            }
          }}
        >
          {title}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  )
}
